import { useDispatch } from 'react-redux'
import * as Staking from '../contracts/stakingv1'
import { setTier } from '../modules/staking/actions'

import { BigSource } from 'big.js'
import { ethers } from 'ethers'

export interface IStakingV1Contract {
  getTier: () => Promise<void>
  withdraw: (amount: BigSource) => Promise<void>
  withdrawAll: () => Promise<void>
  getStakedAmount: (account: string) => Promise<string>
}

const initContract = (provider: ethers.BrowserProvider, account: string) => {
  if (provider) {
    return new ethers.Contract(
      Staking.address,
      Staking.abi as ethers.InterfaceAbi,
      provider,
    )
  }
}

const useStakingContract = (
  provider: ethers.BrowserProvider,
  account: string,
): IStakingV1Contract => {
  const dispatch = useDispatch()
  const contract = initContract(provider, account)

  async function getTier() {
    const tier = await contract?.getTierOf(account)
    dispatch(setTier(Number(tier)))
  }

  async function withdraw(amount: BigSource) {
    const gas = await contract?.unstake.estimateGas(amount.toString())
    return await contract?.unstake(amount.toString(), { gasLimit: gas })
  }

  async function withdrawAll() {
    const gas = await contract?.unstake.estimateGas()
    return await contract?.unstake({ gasLimit: gas })
  }

  async function getStakedAmount(account: string) {
    if (account) {
      const stakedAmount = await contract?.stakedAmountOf(account)

      return stakedAmount
    }
  }

  return { getTier, withdrawAll, getStakedAmount, withdraw }
}

export default useStakingContract
